<div
    #attributesDiv
    class="panel-information grid gap-x-10 gap-y-6 mt-2 mb-8"
    [class]="isWide() ? 'grid-cols-4' : 'grid-cols-2'">
    @for (attribute of dataAttributes(); track $index) {
        <div class="flex flex-col min-w-[200px] max-w-sm flex-1">
            <span class="text-caption text-on-surface font-normal">
                {{ attribute.column }}
            </span>
        </div>
    }
</div>
